import type { SearchBarProps } from "@/types/layout-type";
import { Search } from "lucide-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export default function SearchBarDekstop({ handleSearch }: SearchBarProps) {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const searchParamValue = searchParams.get("search") || "";
    const [prevSearchParam, setPrevSearchParam] = useState(searchParamValue);
    const [search, setSearch] = useState(searchParamValue);

    if (searchParamValue !== prevSearchParam) {
        setPrevSearchParam(searchParamValue);
        setSearch(searchParamValue);
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            const urlSearch = searchParams.get("search") || "";
            if (search !== urlSearch) {
                handleSearch(search);
            }
        }, 500);
        return () => clearTimeout(handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    return (
        <div className="hidden md:flex flex-1 max-w-2xl mx-8">
            <div className="w-full flex">
                <input
                    name="search-dekstop"
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSearch(search);
                        }
                    }}
                    placeholder={t("nav.search_placeholder")}
                    className="flex-1 px-4 py-2 bg-gray-50 dark:bg-dark border border-gray-200 dark:border-dark-2 rounded-l-full outline-none text-sm focus:border-gold transition-colors dark:text-white"
                />
                <button
                    aria-label="Cari"
                    onClick={() => handleSearch(search)}
                    className="px-6 py-2 bg-surface dark:bg-dark-2 border border-surface dark:border-dark-2 rounded-r-full text-gold hover:bg-gold hover:text-white transition-colors">
                    <Search size={18} />
                </button>
            </div>
        </div>
    );
}
